import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { FileInfo, FileUploadStatus } from '../../uploader.interface';

@Component({
  selector: 'glxy-uploader-file',
  templateUrl: './uploader-file.component.html',
  styleUrls: ['./uploader-file.component.scss'],
})
export class GalaxyUploaderFileComponent {
  @HostBinding('class') class = 'glxy-uploader-file';

  @Input() status: FileUploadStatus = FileUploadStatus.InProgress;

  @Input() name!: string;

  @Input() url?: string;

  @Output() deleted: EventEmitter<FileInfo> = new EventEmitter();

  FileUploadStatus = FileUploadStatus;

  /**
   * Emits a delete message when delete button has been selected.
   */
  deleteClick(): void {
    this.deleted.emit();
  }
}
